import * as React from 'react';
import * as _ from 'lodash';
import { Tooltip } from 'react-tooltip';
import Styled from './EasyActions.style';
import { useNavigate } from 'react-router-dom';
import { Icon, Popup, Button, ButtonClean } from '../index';
interface TaskProps {
  id: number;
  icon: string;
  title?: string;
  description?: string;
  isDesktop: boolean;
  buttonText?: string;
  buttonPath?: string;
  renderComplete?: Function;
  completed?: boolean;
  popup: boolean;
  isLoading?: boolean;
  waterSaving?: string;
  energySaving?: string;
  carbonSaving?: string;
  type: any;
}
export const Task: React.FC<TaskProps> = (props) => {
  const {
    id,
    popup,
    icon,
    title,
    description,
    isDesktop,
    buttonText,
    buttonPath,
    renderComplete,
    completed,
    isLoading,
    carbonSaving,
    energySaving,
    waterSaving,
    type,
  } = props;

  const [showPopup, setPopup] = React.useState(false);
  const navigate = useNavigate();
  const splitText = description && description.split('<br>');
  const renderDescription = () => {
    return (
      splitText &&
      splitText.map((el, index) => {
        return <Styled.Description key={index}>{el}</Styled.Description>;
      })
    );
  };

  const renderPopupContent = () => {
    return (
      <>
        <Icon
          size={100}
          icon={icon}
          style={{
            marginBottom: '8px',
          }}
        />
        {completed ? (
          <>
            {' '}
            <Styled.PopupTitle>Congratulations</Styled.PopupTitle>
            <Styled.Description>You have saved</Styled.Description>
            <Styled.CtaWrap>
              <Button full onClick={() => setPopup(!popup)}>
                Close
              </Button>
            </Styled.CtaWrap>
          </>
        ) : (
          <>
            <Styled.PopupTitle>{title}</Styled.PopupTitle>
            {renderDescription()}
            <div style={{ marginBottom: '6px' }}>Monthly savings:</div>
            <Styled.Savings>
              <Styled.SavingItem
                data-tooltip-id="water-tooltip"
                data-tooltip-content="Litres saved"
                data-tooltip-place="top"
              >
                <b>{waterSaving}</b>
                <Icon icon="droplet" style={{ marginLeft: '6px' }} size={28} />
              </Styled.SavingItem>
              <Styled.SavingItem
                data-tooltip-id="energy-tooltip"
                data-tooltip-content="kWh saved"
                data-tooltip-place="top"
              >
                <b>{energySaving}</b>
                <Icon icon="energy" style={{ marginLeft: '6px' }} size={28} />
              </Styled.SavingItem>
              <Styled.SavingItem
                data-tooltip-id="co2-tooltip"
                data-tooltip-content="Kg/m3 CO2"
                data-tooltip-place="top"
              >
                <b>{carbonSaving}</b>
                <Icon icon="co2" style={{ marginLeft: '6px' }} size={28} />
              </Styled.SavingItem>
            </Styled.Savings>
            <Styled.CtaWrap>
              <Button
                full
                isLoading={isLoading}
                onClick={() => {
                  renderComplete ? renderComplete() : navigate(`${buttonPath}`);
                }}
              >
                {buttonText}
              </Button>
            </Styled.CtaWrap>
            <Tooltip id="water-tooltip" />
            <Tooltip id="energy-tooltip" />
            <Tooltip id="co2-tooltip" />
          </>
        )}
      </>
    );
  };

  return (
    <>
      <Styled.Wrap isDesktop={isDesktop} id={id}>
        <Popup
          open={showPopup}
          handleClick={() => setPopup(!showPopup)}
          isDesktop={isDesktop}
        >
          {renderPopupContent()}
        </Popup>

        <ButtonClean
          style={{ width: '100%', textAlign: 'left', fontSize: '18px' }}
          onClick={() => {
            if (popup) {
              setPopup(!showPopup);
            } else if (type.includes('externalLink')) {
              window.open(buttonPath, '_blank');
            } else {
              navigate(`${buttonPath}`);
            }
          }}
        >
          <Styled.TextWrap>
            <Styled.TitleWrap>
              <Styled.Title
                style={{
                  fontSize: isDesktop ? '16px' : '14px',
                }}
              >
                {title} &gt;
              </Styled.Title>
            </Styled.TitleWrap>
          </Styled.TextWrap>
        </ButtonClean>
      </Styled.Wrap>
    </>
  );
};

export default Task;
